var _g;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgBrief = function SvgBrief(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#373737",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.846 6.203V4.447c0-.37.158-.727.442-.994.293-.275.695-.43 1.116-.427h3.205c.862 0 1.545.646 1.545 1.421v1.756c0 .283.224.513.5.513s.5-.23.5-.513V4.447C16.154 3.086 15.006 2 13.609 2h-3.202a2.598 2.598 0 0 0-1.794.696c-.489.459-.767 1.09-.767 1.751v1.756c0 .283.224.513.5.513s.5-.23.5-.513zM2.632 19.369c.404.406.95.632 1.52.631h15.697a2.135 2.135 0 0 0 1.519-.631c.406-.408.633-.963.632-1.542V7.866a2.192 2.192 0 0 0-2.142-2.176H4.151C2.965 5.69 2 6.66 2 7.861v9.968a2.177 2.177 0 0 0 .632 1.54zM3 7.861c0-.63.513-1.145 1.15-1.145h15.7c.63.011 1.14.526 1.15 1.157v9.956c0 .302-.118.592-.332.807-.216.217-.51.339-.817.338H4.15a1.15 1.15 0 0 1-.819-.338A1.138 1.138 0 0 1 3 17.83V7.86z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.51 11l-15.021.021A.49.49 0 0 0 4.49 12l15.021-.021A.49.49 0 0 0 19.51 11z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBrief, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/brief.e1f262c3.svg";
export { ForwardRef as ReactComponent };